import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

import { LanguageSpecificationListingItem } from "../LanguageSpecificationListingItem";
import { LanguageSpecificationListingFilters } from "../useLanguageSpecificationListingFilters";

interface ILanguageSpecificationListingContext {
    languageSpecificationItems: LanguageSpecificationListingItem[];
    isLoading: boolean;
    totalItems: number;
    add(languageSpecificationItem: LanguageSpecificationListingItem): void;
    load(filters: LanguageSpecificationListingFilters): void;
}

const initialContextState: ILanguageSpecificationListingContext = {
    languageSpecificationItems: [],
    isLoading: false,
    totalItems: 0,
    add: contextFunctionInit,
    load: contextFunctionInit
};

export const LanguageSpecificationListingContext = createContext<ILanguageSpecificationListingContext>(
    initialContextState
);
